const SET_MAP_CENTER = 'SET_MAP_CENTER'
const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS'
const SET_MAP_ZOOM = 'SET_MAP_ZOOM'
const SET_SEARCH = 'SET_SEARCH'
const SET_COMPARE = 'SET_COMPARE'
const SET_STACK_BUTTON = 'SET_STACK_BUTTON'
const SET_STACK_POPUP = 'SET_STACK_POPUP'
const SET_TIMELINE = 'SET_TIMELINE'
const SET_FILTERS = 'SET_FILTERS'
const SET_GROUP = 'SET_GROUP'
const SET_FILTERS_DISTRIBUTION = 'SET_FILTERS_DISTRIBUTION'
const SET_SETTINGS_MARKER_TINY = 'SET_SETTINGS_MARKER_TINY'
const SET_SETTINGS_MARKER_SCORE = 'SET_SETTINGS_MARKER_SCORE'
const SET_SETTINGS_MARKER_ALL = 'SET_SETTINGS_MARKER_ALL'
const SET_SETTINGS_MARKER_MAX = 'SET_SETTINGS_MARKER_MAX'
const SET_SETTINGS_MARKER_ACRONYM = 'SET_SETTINGS_MARKER_ACRONYM'
const SET_REFRESHING_DATA = 'SET_REFRESHING_DATA'
const SET_REFRESHING_ZONES = 'SET_REFRESHING_ZONES'
const SET_NO_UI = 'SET_NO_UI'
const SET_LOCALE = 'SET_LOCALE'
const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE'
const SET_CURRENT_MAP_CENTER = 'SET_CURRENT_MAP_CENTER'
const SET_CURRENT_MAP_RADIUS = 'SET_CURRENT_MAP_RADIUS'
const SET_CURRENT_ZOOM = 'SET_CURRENT_ZOOM'
const SET_LEGENDS = 'SET_LEGENDS'

const state = () => {
  return {
    locale: 'fr',
    currentRoute: null,
    map: {
      center: null,
      bounds: null,
      zoom: null,
      options: {
        clickableIcons: false,
        disableDefaultUI: true,
        styles: [
          {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'administrative.province',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#737373',
              },
            ],
          },
          {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#efefef',
              },
            ],
          },
          {
            featureType: 'landscape.natural',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#dadada',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
              {
                color: '#696969',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff',
              },
            ],
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#b3b3b3',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#ffffff',
              },
            ],
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#d6d6d6',
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [
              {
                visibility: 'on',
              },
              {
                color: '#ffffff',
              },
              {
                weight: 1.8,
              },
            ],
          },
          {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
              {
                color: '#d7d7d7',
              },
            ],
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [
              {
                color: '#808080',
              },
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
              {
                color: '#c9c9c9',
              },
            ],
          },
        ],
      },
      gmap: null,
    },
    search: {
      active: false,
    },
    compare: {
      active: false,
    },
    currentMapCenter: '39.760, -98.50',
    currentMapRadius: '470000',
    currentZoom: 0,
    stack: {
      button: false,
      popUp: false,
    },
    filters: {
      active: false,
      distribution: false,
      group: false,
    },
    legends: {
      active: false,
    },
    timeline: {
      active: false,
    },
    settings: {
      marker: {
        tiny: false,
        score: false,
        all: false,
        max: 50,
        acronym: false,
      },
    },
    refreshing: {
      data: false,
      zones: false,
    },
    noUi: false,
  }
}

const mutations = {
  [SET_MAP_CENTER]: (state, center) => {
    state.map.center = center
  },
  [SET_MAP_BOUNDS]: (state, bounds) => {
    state.map.bounds = bounds
  },
  [SET_MAP_ZOOM]: (state, zoom) => {
    state.map.zoom = zoom
  },
  [SET_SEARCH]: (state, bool) => {
    state.search.active = bool
  },
  [SET_COMPARE]: (state, bool) => {
    state.compare.active = bool
  },
  [SET_STACK_BUTTON]: (state, bool) => {
    state.stack.button = bool
  },
  [SET_STACK_POPUP]: (state, bool) => {
    state.stack.popUp = bool
  },
  [SET_LEGENDS]: (state, bool) => {
    state.legends.active = bool
  },
  [SET_TIMELINE]: (state, bool) => {
    state.timeline.active = bool
  },
  [SET_FILTERS]: (state, bool) => {
    state.filters.active = bool
  },
  [SET_GROUP]: (state, bool) => {
    state.filters.group = bool
  },
  [SET_FILTERS_DISTRIBUTION]: (state, bool) => {
    state.filters.distribution = bool
  },
  [SET_SETTINGS_MARKER_TINY]: (state, bool) => {
    state.settings.marker.tiny = bool
  },
  [SET_SETTINGS_MARKER_SCORE]: (state, bool) => {
    state.settings.marker.score = bool
  },
  [SET_SETTINGS_MARKER_ALL]: (state, bool) => {
    state.settings.marker.all = bool
  },
  [SET_SETTINGS_MARKER_MAX]: (state, maximum) => {
    state.settings.marker.max = maximum
  },
  [SET_SETTINGS_MARKER_ACRONYM]: (state, bool) => {
    state.settings.marker.acronym = bool
  },
  [SET_REFRESHING_DATA]: (state, bool) => {
    state.refreshing.data = bool
  },
  [SET_REFRESHING_ZONES]: (state, bool) => {
    state.refreshing.zones = bool
  },
  [SET_NO_UI]: (state, bool) => {
    state.noUi = bool
  },
  [SET_LOCALE]: (state, locale) => {
    state.locale = locale
  },
  [SET_CURRENT_ROUTE]: (state, currentRoute) => {
    state.currentRoute = currentRoute
  },
  [SET_CURRENT_MAP_CENTER]: (state, center) => {
    state.currentMapCenter = center
  },
  [SET_CURRENT_MAP_RADIUS]: (state, radius) => {
    state.currentMapRadius = radius
  },
  [SET_CURRENT_ZOOM]: (state, zoom) => {
    state.currentZoom = zoom
  },
}

const actions = {
  setCurrentRoute: ({ commit }, currentRoute) => {
    commit(SET_CURRENT_ROUTE, currentRoute)
  },
  initMapCenter: ({ commit }, locations) => {
    const center = locations.length ? locations[0]._geoloc : { lat: 0, lng: 0 }
    commit(SET_MAP_CENTER, center)
  },
  initSettings: ({ commit, dispatch }, query) => {
    if (query.marker_score) {
      dispatch('toggleMarkerScore', true)
    }
    if (query.marker_tiny) {
      dispatch('toggleMarkerSize', true)
    }
    if (query.marker_acronym) {
      dispatch('toggleMarkerAcronym', true)
    }
    if (query.marker_all) {
      dispatch('toggleMarkerAll', true)
    }
    if (query.no_ui) {
      commit(SET_NO_UI, true)
    }
    Promise.resolve()
  },
  updateStackButton: ({ commit }, { currCountries, countries }) => {
    let fund = []
    currCountries.forEach(currKey => {
      countries.forEach(c => {
        if (currKey === c.key && c.max_level > 1) {
          fund.push(c)
        }
      })
    })
    if (fund.length > 0) {
      commit(SET_STACK_BUTTON, true)
    } else {
      commit(SET_STACK_BUTTON, false)
    }
  },
  updateMapCenterFromLocations: ({ commit }, locations) => {
    if (locations.length > 0) {
      const center = locations[0]._geoloc
      commit(SET_MAP_CENTER, center)
    }
  },
  setMapBounds: ({ commit }, bounds) => {
    commit(SET_MAP_BOUNDS, bounds)
  },
  setMapZoom: ({ commit }, zoom) => {
    commit(SET_MAP_ZOOM, zoom)
  },
  setCurrentMapCenter: ({ commit }, center) => {
    commit(SET_CURRENT_MAP_CENTER, center)
  },
  setCurrentMapRadius: ({ commit }, radius) => {
    commit(SET_CURRENT_MAP_RADIUS, radius)
  },
  setCurrentZoom: ({ commit }, zoom) => {
    commit(SET_CURRENT_ZOOM, zoom)
  },
  toggleSearch: ({ commit }, bool) => {
    commit(SET_SEARCH, bool)
  },
  toggleCompare: ({ commit }, bool) => {
    commit(SET_COMPARE, bool)
  },
  toggleStackPopUp: ({ commit }, bool) => {
    commit(SET_STACK_BUTTON, !bool)
    commit(SET_STACK_POPUP, bool)
  },
  toggleLegends: ({ commit }, bool) => {
    commit(SET_LEGENDS, bool)
  },
  toggleTimeline: ({ commit, dispatch }, bool) => {
    commit(SET_TIMELINE, bool)
    commit(SET_FILTERS, false)
    dispatch('data/setCurrentLocation', null, { root: true })
  },
  toggleFilters: ({ commit }, bool) => {
    commit(SET_FILTERS, bool)
    commit(SET_TIMELINE, false)
  },
  toggleFiltersGroup: ({ commit }, bool) => {
    commit(SET_GROUP, bool)
  },
  toggleFiltersDistribution: ({ commit }, bool) => {
    commit(SET_FILTERS_DISTRIBUTION, bool)
  },
  toggleMarkerSize: ({ commit }, bool) => {
    commit(SET_SETTINGS_MARKER_TINY, bool)
    if (bool) {
      commit(SET_SETTINGS_MARKER_SCORE, false)
    }
  },
  toggleMarkerScore: ({ commit }, bool) => {
    commit(SET_SETTINGS_MARKER_SCORE, bool)
    if (bool) {
      commit(SET_SETTINGS_MARKER_TINY, false)
    }
  },
  toggleRefreshZones: ({ commit }, bool) => {
    commit(SET_REFRESHING_ZONES, bool)
  },
  toggleRefreshData: ({ commit }, bool) => {
    commit(SET_REFRESHING_DATA, bool)
  },
  toggleMarkerAll: ({ commit }, bool) => {
    commit(SET_SETTINGS_MARKER_ALL, bool)
    if (bool) {
      commit(SET_SETTINGS_MARKER_MAX, 10000)
    } else {
      commit(SET_SETTINGS_MARKER_MAX, 50)
    }
  },
  toggleMarkerAcronym: ({ commit }, bool) => {
    commit(SET_SETTINGS_MARKER_ACRONYM, bool)
  },
  updateLocale: ({ commit }, locale) => {
    commit(SET_LOCALE, locale)
  },
}

const getters = {
  isZonesIntentionView: state => {
    const routeIntentionView = ['zonesIntention', 'divisionZonesIntention']
    return routeIntentionView.includes(state.currentRoute)
  },
  isMarkersIntentionView: state => {
    return state.currentRoute === 'markersIntention'
  },
  isIntentionView: state => {
    const routeIntentionView = ['zonesIntention', 'divisionZonesIntention', 'markersIntention']
    return routeIntentionView.includes(state.currentRoute)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
